export default __webpack_public_path__ + "static/media/files_empty_state.01531df9.svg";